import { type MouseEvent, type RefObject, useCallback, useState } from 'react';
import type { FormSegment } from '../../../../../../../../../../modules/audiences/AudienceForm/types.ts';

export const useDropdownState = (value: FormSegment[]) => {
  const [open, setOpen] = useState(false);
  const [expanded, setExpanded] = useState<Record<string, boolean>>({});
  const [query, setQuery] = useState('');

  const handleToggle = useCallback(() => {
    setOpen(prevOpen => !prevOpen);
  }, []);

  const handleClose = useCallback(
    (event: Event, anchorRef?: RefObject<HTMLDivElement | null>) => {
      if (anchorRef?.current?.contains(event.target as Node)) {
        return;
      }

      setOpen(false);

      if (value.length === 0) {
        setQuery('');
      }
    },
    [value.length]
  );

  const toggleExpand = useCallback((stateId: string, event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();

    setExpanded(m => ({ ...m, [stateId]: !m[stateId] }));
  }, []);

  return {
    open,
    setOpen,
    expanded,
    query,
    setQuery,
    handleToggle,
    handleClose,
    toggleExpand,
  };
};
